.atm_26_glywfm{background:none;}
.atm_3f_glywfm{border:none;}
.atm_9j_tlke0l{cursor:pointer;}
.atm_c8_18uv5lq.atm_c8_18uv5lq{font-size:initial;}
.atm_l8_idpfg4{padding:0;}
